import React, { FC } from 'react';
import styled from 'styled-components';
import DesktopChatOverlay from './components/desktop/DesktopChatOverlay';
import MobileChatButton from './components/mobile/MobileChatButton';
import MobileChatOverlay from './components/mobile/MobileChatOverlay';
import useTwilioDesktop from './hooks/useTwilioDesktop';

const MobileRootContainer = styled.div`
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1100;
`;

const ChatOverlay: FC = () => {
  const { isDesktop, isBoothProfilePage } = useTwilioDesktop();

  if (!isDesktop) {
    return (
      <MobileRootContainer>
        <MobileChatOverlay />
        {!isBoothProfilePage && <MobileChatButton id="mobile-chat-button" />}
      </MobileRootContainer>
    );
  }

  return (
    <DesktopChatOverlay />
  );
};

export default React.memo(ChatOverlay);
